import SupplierProducts from '../pages/SupplierProducts.vue';
import SupplierProductDetail from '../pages/SupplierProductDetail.vue';
import SupplierProductForm from '../pages/SupplierProductForm.vue';
const supplierProductRoutes = [
  {
    path: 'supplier-products/:supplierProductType',
    name: 'محصولات و کالا',
    component: SupplierProducts,
  },
  {
    path: 'supplier-products/:supplierProductType/form/:actionName',
    name: 'فرم محصولات و کالا',
    component: SupplierProductForm,
  },
  {
    path: 'supplier-products/:supplierProductType/detail/:id',
    name: 'ویرایش محصولات و کالا',
    component: SupplierProductDetail,
  },
];

export default supplierProductRoutes;
